import React from 'react';

import Button from '@material-ui/core/Button';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';

import locations from './locations';


const useStyles = makeStyles(theme => ({
    form: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        maxWidth: 460,
        '& .MuiInputBase-root': {
            width: 458,
            maxWidth: '100%'
        }
    },
    formButtons: {
        marginTop: theme.spacing(2)
    }
}));

const UserDetailForm = props => {
    const classes = useStyles();

    const {
        user
    } = props;

    const [showProgress, setShowProgress] = React.useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

    const [state, setState] = React.useState({
        first_name: user.first_name,
        last_name: user.last_name,
        province_id: user.province_id,
        email: user.email,
        phone_number: user.phone_number,
        is_couple: user.is_couple,
        is_officiant: user.is_officiant,
        is_admin: user.is_admin,
        can_add_couple: user.can_add_couple,
        is_active: user.is_active,
        officiant_info: user.officiant_info,
    });

    const updateState = (value, name) => {
        let data = {
            ...state
        };
        if (name == 'location' || name == 'profile_link') {
            data.officiant_info[name] = value;
        } else {
            data[name] = value;
        }
        setShowSuccessMessage(false);
        setState(data);
    }
    const handleChange = name => event => {
        let value = event.target.value;
        updateState(value, name);
    }

    const provinces = window.provinces;

    const submitForm = type => () => {
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            const url = `/api/admin/users/${user.id}`;
            setShowProgress(true);
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setShowSuccessMessage(true);
                })
                .catch(reason => {
                    alert('Please try again');
                })
                .finally(() => {
                    resolve();
                    setTimeout(() => {
                        setShowProgress(false);
                        if (type == 'save') {
                            window.location = '/admin/users';
                        }
                    }, 200);
                })
        });
    }

    return (
        <form className={classes.form}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField id="first-name" label="First Name" value={state.first_name || ''} onChange={handleChange('first_name')} fullWidth />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField id="last-name" label="Last Name" value={state.last_name || ''} onChange={handleChange('last_name')} fullWidth />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="User Province"
                        value={state.province_id}
                        onChange={handleChange('province_id')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Location"
                        value={state.officiant_info && state.officiant_info.location ? state.officiant_info.location : ''}
                        onChange={handleChange('location')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {locations.map(option => (
                            <MenuItem key={option.id} value={option.value}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="profile-link"
                        label="Profile Link"
                        value={state.officiant_info && state.officiant_info.profile_link ? state.officiant_info.profile_link : ''}
                        onChange={handleChange('profile_link')}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField id="email" label="Email (Username)" value={state.email || ''} onChange={handleChange('email')} fullWidth />
                </Grid>
                <Grid item xs={12}>
                    <TextField id="phone-number" label="Phone Number" value={state.phone_number || ''} onChange={handleChange('phone_number')} fullWidth />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Officiant"
                        value={state.is_officiant}
                        onChange={handleChange('is_officiant')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Admin"
                        value={state.is_admin}
                        onChange={handleChange('is_admin')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Couple"
                        value={state.is_couple}
                        onChange={handleChange('is_couple')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        id="add-couples"
                        label="Add Couples"
                        value={state.can_add_couple}
                        onChange={handleChange('can_add_couple')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={state.is_active}
                        onChange={handleChange('is_active')}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        <MenuItem value={true}>Active</MenuItem>
                        <MenuItem value={false}>Inactive</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} className={classes.formButtons}>
                    <Box component="span">
                        <Button
                            variant="contained"
                            onClick={submitForm('continue')}
                            disabled={showProgress ? true : false}
                        >
                            Save & Continue Editing
                        </Button>
                        <Button
                            style={{marginLeft: 10}}
                            variant="contained"
                            color="primary"
                            onClick={submitForm('save')}
                            disabled={showProgress ? true : false}
                        >
                            Save
                        </Button>
                    </Box>
                    <Box component="span" ml={2}>
                        {showProgress === true && <CircularProgress size={20} />}
                        {showSuccessMessage === true && <Typography variant="overline" color="primary">Success!</Typography>}
                    </Box>
                </Grid>
            </Grid>
        </form>
    )
}

export default UserDetailForm;
